export default __webpack_public_path__ + "static/media/calculationsIcon.9a20fb16.svg";